import React from 'react'

export default ({ className = 'nav-logo', slug }) => (
    <img
        className={className}
        src={`${window.location.origin}/stack/brand/${slug}/logos/color-full`}
        alt={slug}
    />
)
